"use client"

import { useState } from "react"
import { Loader2, ShieldCheck } from "lucide-react"
import { verifikasiMasukDuaLangkah } from "@/modules/akun/actions/auth-actions"
import type { ModeKodeDuaLangkah } from "@/modules/akun/domain/dua-langkah"
import { KolomTeks, PesanGalat } from "@/modules/akun/ui/kolom"

export function LangkahDuaMasuk({ onSelesai, onBatal }: { onSelesai: () => void; onBatal: () => void }) {
  const [mode, setMode] = useState<ModeKodeDuaLangkah>("totp")
  const [kode, setKode] = useState("")
  const [percayai, setPercayai] = useState(false)
  const [memproses, setMemproses] = useState(false)
  const [galat, setGalat] = useState<string | null>(null)

  const kirim = async () => {
    if (memproses) return
    setGalat(null)
    setMemproses(true)
    const hasil = await verifikasiMasukDuaLangkah({ mode, kode, percayai })
    if (!hasil.ok) {
      setMemproses(false)
      setGalat(hasil.pesan)
      return
    }
    onSelesai()
  }

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => {
        event.preventDefault()
        void kirim()
      }}
    >
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <ShieldCheck className="h-5 w-5" />
        </span>
        <div>
          <h2 className="font-display text-base font-semibold text-foreground">Verifikasi 2 langkah</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            {mode === "totp" ? "Masukkan 6 angka dari aplikasi authenticator kamu." : "Masukkan salah satu kode cadangan. Setiap kode hanya berlaku sekali."}
          </p>
        </div>
      </div>

      <KolomTeks
        label={mode === "totp" ? "Kode authenticator" : "Kode cadangan"}
        value={kode}
        onChange={setKode}
        inputMode={mode === "totp" ? "numeric" : "text"}
        autoComplete="one-time-code"
        autoCapitalize="none"
        spellCheck={false}
        maxLength={mode === "totp" ? 7 : 24}
        disabled={memproses}
        autoFocus
        required
      />

      <label className="flex cursor-pointer items-center gap-2 text-sm text-foreground">
        <input type="checkbox" checked={percayai} onChange={(event) => setPercayai(event.target.checked)} className="h-4 w-4 rounded border-border accent-[hsl(var(--primary))]" />
        Percayai perangkat ini selama 30 hari
      </label>

      <PesanGalat pesan={galat} />

      <button type="submit" disabled={memproses || kode.trim().length < 6} className="btn-primary w-full">
        {memproses ? <Loader2 className="h-4 w-4 animate-spin" /> : "Verifikasi"}
      </button>

      <div className="flex items-center justify-between text-sm">
        <button
          type="button"
          onClick={() => {
            setMode((sekarang) => (sekarang === "totp" ? "cadangan" : "totp"))
            setKode("")
            setGalat(null)
          }}
          className="font-medium text-primary hover:underline"
        >
          {mode === "totp" ? "Pakai kode cadangan" : "Pakai aplikasi authenticator"}
        </button>
        <button type="button" onClick={onBatal} className="text-muted-foreground hover:underline">
          Batal
        </button>
      </div>
    </form>
  )
}
